import { type ReactElement, useContext } from "react"

import { useTranslation } from "react-i18next"
import { useQuery } from "react-query"
import { useParams } from "react-router-dom"

import { Grid } from "@mui/material"
import type { AxiosResponse } from "axios"

import { SankeyChart, type SankyChartData } from "../../../components/graphs/SankeyChart"
import { KonanAPI } from "../../../services/KonanAPI"
import { InsightList } from "../../../types/generated/api/InsightList"
import { getDecisionFunnelData } from "../../simulationsReport/Helpers"
import { ReportContext } from "../Context"
import type { DecisionFunnelProps, InsightProps } from "../interfaces"

export function DecisionFunnel(props: Readonly<Omit<InsightProps, "isFeedback">>): ReactElement {
  const { insight } = props
  const { id: projectId } = useParams<{ id: string }>() // Extract project ID from URL params

  const { report } = useContext(ReportContext)

  const { t } = useTranslation("insights")

  const { data: insightData, isLoading } = useQuery<AxiosResponse<DecisionFunnelProps>>(
    ["Decision-Funnel", projectId, report?.uuid, insight.uuid],
    () =>
      KonanAPI.fetchInsight({
        project_uuid: projectId as string,
        report_uuid: report?.uuid as string,
        insight_uuid: insight.uuid,
      }),
    {
      enabled: !!report?.uuid && !!projectId && !!insight.uuid && insight.status === InsightList.status.SUCCEEDED,
      refetchOnMount: false,
    },
  )

  const DecisionFunnelData = getDecisionFunnelData({
    node_percentages: insightData?.data.data,
    totalRequests: insightData?.data.count,
  })

  return (
    <Grid item xs={12}>
      <SankeyChart
        title={t("DecisionFunnel.title")}
        graphHeight={340}
        data={DecisionFunnelData as SankyChartData}
        isLoading={isLoading}
      />
    </Grid>
  )
}
